// extracted by mini-css-extract-plugin
export default {"root":"_2nX5V","collapsed":"_3SLcG"};